import axios from "axios";

export default {
  namespaced: true,
  state: {
    salesreps: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    salesrepsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = state.isReceiving==true ? true : false;
    },
    RECEIVED_SALESREPS(state, payload) {
      state.salesreps = payload;
      state.isReceiving = false;
    },
    RECEIVING_SALESREPS(state) {
      state.isReceiving = true;
    },
    RECEIVED_SALESREP(state, payload) {
      state = Object.assign(state, {
        salesreps: [...state.salesreps, payload],
        isReceiving: false,
      })
    },
    RECEIVING_SALESREP(state) {
      state.isReceiving = true;
    },
    UPDATED_SALESREP(state, payload) {
      console.log(state.salesreps);
      console.log(payload);
      let index = state.salesreps.findIndex(salesrep => salesrep._id === payload._id);
      state = Object.assign(state, {
        salesreps: state.salesreps.map((salesrep, i) => {
          if (i === index) {
            return Object.assign({}, salesrep, payload);
          }
          return salesrep;
        }),
        isUpdating: false,
        salesrepsMessage: 'SalesReps has been updating!',
      })
    },
    UPDATING_SALESREP(state) {
      state.isUpdating = true;
    },
  },
  actions: {
    async deleteRepAreaRequest({dispatch}, payload) {
      try{
        dispatch("doNothing", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/reparea/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteRepVisitRequest({dispatch}, payload) {
      try{
        dispatch("doNothing", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/repvisit/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getSalesRepsRequest({dispatch}) {
      dispatch("receivingSalesReps");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/salesreps';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: headers})
      .then(res => {
        dispatch("receiveSalesReps", res.data);
      })
    },
    async insertRepAreaRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/reparea/' + payload.userid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertRepVisitRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/repvisit/' + payload.userid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateSalesRepOptionsRequest({dispatch}, payload) {
      dispatch("updatingSalesRep");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/salesrep/options/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then(function (res) {
        dispatch("updateSalesRep", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    updateSalesRepCommissionRequest({dispatch}, payload) {
      dispatch("updatingSalesRep");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/salesrep/commission/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then(function (res) {
        dispatch("updateSalesRep", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateRepAreaRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/reparea/' + payload.repareaid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateRepVisitRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/repvisit/' + payload.repvisitid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveSalesReps({commit}, payload) {
      commit("RECEIVED_SALESREPS", payload)
    },
    receivingSalesReps({commit}) {
      commit("RECEIVING_SALESREPS")
    },
    receiveSalesRep({commit}, payload) {
      commit("RECEIVED_SALESREP", payload)
    },
    receivingSalesRep({commit}) {
      commit("RECEIVING_SALESREP")
    },
    updateSalesRep({commit}, payload) {
      commit("UPDATED_SALESREP", payload)
    },
    updatingSalesRep({commit}) {
      commit("UPDATING_SALESREP")
    },
  },
};
